import { _x } from '@wordpress/i18n'
import { useConfigContext } from './ConfigContext'

export default function NoResults() {
  const { contactUrl } = useConfigContext()

  return (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: '15%'
      }}
      className="d-flex flex-column justify-content text-center py-4"
    >
      <h3 className="display-3">
        {_x('No Sermon Found', 'Sermons List No Results Title', 'icf')}
      </h3>
      {contactUrl && (
        <div className="mt-4">
          <a href={contactUrl} className="btn btn-default">
            {_x('Contact', 'Sermons List No Results Contact Button', 'icf')}
          </a>
        </div>
      )}
    </div>
  )
}
